// import { useSelector } from "react-redux";

export const useIsUserBlocked = () => {
  // const isUserAuthentication = useSelector(
  //   (state) => state?.user?.user?.data?.isUserAuthentication
  // );

  return false;
};
